export default __webpack_public_path__ + "fullscreen-symbol.png";